import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, Defs, LinearGradient, Stop, Rect, G, ClipPath } from "react-native-svg";

export default function PaymentsIcon(props) {
  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G clipPath="url(#clip0_12867_168184)">
          <Path
            d="M15.0002 23.4375C13.3315 23.4375 11.7002 22.9427 10.3126 22.0155C8.92508 21.0884 7.84363 19.7706 7.20501 18.2289C6.5664 16.6871 6.39931 14.9906 6.72487 13.3539C7.05043 11.7172 7.85403 10.2138 9.03403 9.03379C10.214 7.85378 11.7175 7.05019 13.3542 6.72463C14.9909 6.39907 16.6874 6.56616 18.2291 7.20477C19.7709 7.84338 21.0886 8.92484 22.0158 10.3124C22.9429 11.6999 23.4377 13.3312 23.4377 15C23.4353 17.237 22.5455 19.3817 20.9637 20.9635C19.3819 22.5453 17.2373 23.435 15.0002 23.4375V23.4375ZM15.0002 8.4375C13.7023 8.4375 12.4335 8.82239 11.3543 9.54348C10.2751 10.2646 9.43399 11.2895 8.93729 12.4886C8.44059 13.6878 8.31063 15.0073 8.56384 16.2803C8.81706 17.5533 9.44208 18.7226 10.3599 19.6404C11.2776 20.5582 12.447 21.1832 13.72 21.4364C14.993 21.6896 16.3125 21.5597 17.5116 21.063C18.7107 20.5663 19.7357 19.7251 20.4568 18.6459C21.1779 17.5667 21.5627 16.2979 21.5627 15C21.5608 13.2601 20.8687 11.5921 19.6384 10.3618C18.4082 9.13153 16.7401 8.43949 15.0002 8.4375V8.4375Z"
            fill="url(#paint0_linear_12867_168184)"
          />
          <Path
            d="M15.0002 19.6875C17.5891 19.6875 19.6877 17.5888 19.6877 15C19.6877 12.4112 17.5891 10.3125 15.0002 10.3125C12.4114 10.3125 10.3127 12.4112 10.3127 15C10.3127 17.5888 12.4114 19.6875 15.0002 19.6875Z"
            fill="url(#paint1_linear_12867_168184)"
          />
          <Path
            d="M9.84375 3.74997H5.625V0.468716C5.62477 0.377709 5.59806 0.288737 5.54812 0.212657C5.49817 0.136578 5.42716 0.0766816 5.34375 0.0402788C5.26079 0.0043084 5.1693 -0.00729973 5.07998 0.00681179C4.99067 0.0209233 4.90721 0.0601712 4.83938 0.119966L0.151879 4.33872C0.10293 4.38268 0.0637836 4.43645 0.0369855 4.49653C0.0101874 4.55662 -0.00366211 4.62167 -0.00366211 4.68747C-0.00366211 4.75326 0.0101874 4.81831 0.0369855 4.8784C0.0637836 4.93848 0.10293 4.99226 0.151879 5.03622L4.83938 9.25497C4.92635 9.33308 5.03936 9.37588 5.15625 9.37497C5.2208 9.37403 5.28452 9.36033 5.34375 9.33465C5.42716 9.29825 5.49817 9.23835 5.54812 9.16227C5.59806 9.0862 5.62477 8.99722 5.625 8.90622V5.62497H9.84375C9.96807 5.62497 10.0873 5.57558 10.1752 5.48767C10.2631 5.39976 10.3125 5.28054 10.3125 5.15622V4.21872C10.3125 4.0944 10.2631 3.97517 10.1752 3.88726C10.0873 3.79935 9.96807 3.74997 9.84375 3.74997Z"
            fill="url(#paint2_linear_12867_168184)"
          />
          <Path
            d="M29.8446 24.9637L25.1571 20.7449C25.0897 20.6844 25.0063 20.6448 24.9168 20.6307C24.8274 20.6166 24.7357 20.6288 24.653 20.6657C24.5703 20.7025 24.5001 20.7626 24.4508 20.8386C24.4015 20.9145 24.3753 21.0031 24.3752 21.0937V24.3749H20.1565C20.0322 24.3749 19.9129 24.4243 19.825 24.5122C19.7371 24.6001 19.6877 24.7194 19.6877 24.8437V25.7812C19.6877 25.9055 19.7371 26.0247 19.825 26.1126C19.9129 26.2005 20.0322 26.2499 20.1565 26.2499H24.3752V29.5312C24.3755 29.6222 24.4022 29.7112 24.4521 29.7872C24.5021 29.8633 24.5731 29.9232 24.6565 29.9596C24.7157 29.9853 24.7794 29.999 24.844 29.9999C24.9596 29.9999 25.0711 29.9572 25.1571 29.8799L29.8446 25.6612C29.8936 25.6172 29.9327 25.5634 29.9595 25.5034C29.9863 25.4433 30.0002 25.3782 30.0002 25.3124C30.0002 25.2466 29.9863 25.1816 29.9595 25.1215C29.9327 25.0614 29.8936 25.0076 29.8446 24.9637V24.9637Z"
            fill="url(#paint3_linear_12867_168184)"
          />
        </G>
        <Defs>
          <LinearGradient
            id="paint0_linear_12867_168184"
            x1="6.56274"
            y1="10.2221"
            x2="14.6859"
            y2="26.8203"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
          <LinearGradient
            id="paint1_linear_12867_168184"
            x1="10.3127"
            y1="12.3456"
            x2="14.8256"
            y2="21.5668"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
          <LinearGradient
            id="paint2_linear_12867_168184"
            x1="-0.0036624"
            y1="2.03389"
            x2="4.23956"
            y2="11.5755"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
          <LinearGradient
            id="paint3_linear_12867_168184"
            x1="19.6877"
            y1="22.6581"
            x2="23.9327"
            y2="32.1992"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
          <ClipPath id="clip0_12867_168184">
            <Rect width="30" height="30" fill="white" />
          </ClipPath>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
